module.exports = __webpack_public_path__ + "static/media/footer-mobile.3875847d.png";